export enum Pages {
  HOME = '',
  BOOST = 'boost',
  FRIENDS = 'friends',
  TASKS = 'tasks',
  STATS = 'stats',
  COMING_SOON = 'comingSoon'
}
